import { useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import Alooma from 'services/alooma';
import CardTagSquare from 'components/molecules/CardTagSquare/CardTagSquare';
import { MY_GLOBAL_ITEMS } from 'consts/myItemsGroups';
import { useCardTagSquareBreakpoints } from 'hooks/grid/useCardTagSquareBreakpoint';
import BaseSwiperSlider from 'components/organisms/BaseSwiperSlider/BaseSwiperSlider';
import { getMyGlobalItemsGroup } from 'store/myItems/store/selectors';
import useAction from 'hooks/useAction';
import { fetchGlobalItems } from 'store/globalSearch/actions';

const SavedFromStoreCards = () => {
  const breakpoints = useCardTagSquareBreakpoints();

  const { tags, page, tagsLeft } = useSelector(getMyGlobalItemsGroup);

  const currentRef = useRef({ page, tagsLeft });

  const fetchGlobalItemsFUnc = useAction(fetchGlobalItems);

  const fetchMoreTags = useCallback(() => {
    if (currentRef.current.tagsLeft)
      fetchGlobalItemsFUnc({
        includeGlobal: false,
        includeUser: true,
        page: currentRef.current.page + 1,
      });
  }, [fetchGlobalItemsFUnc]);

  const sliderSettings = useMemo(
    () => ({
      breakpoints,
      on: {
        reachEnd: fetchMoreTags,
      },
    }),
    [breakpoints, fetchMoreTags],
  );

  useEffect(() => {
    currentRef.current = { page, tagsLeft };
  }, [page, tagsLeft]);

  return (
    <BaseSwiperSlider v2 sliderSettings={sliderSettings}>
      {tags.map(tag => (
        <div key={tag.id}>
          <Alooma.TagIdContext.Provider value={tag.id}>
            <Alooma.RuleIdContext.Provider value={tag.rule_id}>
              <CardTagSquare group={MY_GLOBAL_ITEMS} tag={tag} />
            </Alooma.RuleIdContext.Provider>
          </Alooma.TagIdContext.Provider>
        </div>
      ))}
    </BaseSwiperSlider>
  );
};

export default SavedFromStoreCards;
